import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=380481e0&scoped=true"
import script from "./Spacer.vue?vue&type=script&lang=js"
export * from "./Spacer.vue?vue&type=script&lang=js"
import style0 from "./Spacer.vue?vue&type=style&index=0&id=380481e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380481e0",
  null
  
)

export default component.exports